import { render, staticRenderFns } from "./siji.vue?vue&type=template&id=53d10e5a&scoped=true"
import script from "./siji.vue?vue&type=script&lang=js"
export * from "./siji.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d10e5a",
  null
  
)

export default component.exports